
// Export
module.exports =
  {

    // Upload file
    uploadFile: function (file)
    {

      APPLICATION._APPLICATION.uploadFile(file);

      // Remove any image wrappers
      $('.img-responsive', file.closest('.form-group')).parent().remove();

    },

    // Remove image
    removeImage: function (file, e)
    {

      // Set the hidden field value
      $('input[name*=delete]', file.closest('.form-group')).val(1);

      // Reset the label value
      $('.js-file_label', file.closest('.form-group')).val('');

      // Remove any image wrappers
      $('.img-responsive', file.closest('.form-group')).parent().remove();

      e.preventDefault();
    },

    // Account search scripts
    accountSearch:
      {

        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.load($('#accounts'), APPLICATION._PATH_PREFIX + 'installation/accounts', 'Installation', 'accounts')
        }

      },

    // Accounts scripts
    accounts:
      {

        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.processLinks('#accounts', 'Installation', 'accounts')
        }

      },

    // Edit account scripts
    editAccount:
      {

        // Method-wide scripts
        _init: function ()
        {

          // Get the password script
          $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
            {

              // On generating the password
              $('#generate_password').not('.js-ignore').click(function ()
                {

                  // Generate the password
                  PasswordGenerator.generate(function (password)
                    {

                      // Show the generated password
                      $('#generated_password').val(password)

                      // Enter the password
                      $('#password').val(password)

                    }
                  )

                }
              ).addClass('js-ignore')

            }
          )

          // On clicking the generated password
          $('#generated_password').not('.js-ignore').click(function ()
            {
              this.select()
            }
          ).addClass('js-ignore')

          // On changing the status
          $('#account_status_id').not('.js-ignore').change(function ()
            {

              // If inactive
              if ('2' === $(this).val())
              {
                $('#inactive-all-wrapper').removeClass('hidden')
              }

              // Otherwise
              else
              {
                $('#inactive-all-wrapper').addClass('hidden')
              }

            }
          ).addClass('js-ignore')

        },

        // Refresh account group
        refreshAccountGroup: function (account_group_id, owner_id)
        {

          // Close the modal
          $('body').removeClass('show-modal')

          // Load the account groups
          APPLICATION._APPLICATION.loadDropdown($('#account_group_id'), APPLICATION._PATH_PREFIX + 'account-group/dropdown/' + owner_id + '?account_group_id=' + account_group_id, 'AccountGroup', 'dropdown')

        }

      },

    // Dashboard scripts
    dashboard:
      {

        // Method-wide scripts
        _init: function ()
        {

          if (0 !== $('.js-can-search').length)
          {
            APPLICATION._APPLICATION.search($('.js-url'))
          }

          // Get the script
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY, function ()
          {

          })

        }


      },

    // Dashboard Lite scripts (same as dashboard but optimized)
    dashboardLite:
      {

        // Method-wide scripts
        _init: function ()
        {

          if (0 !== $('.js-can-search').length)
          {
            APPLICATION._APPLICATION.search($('.js-url'))
          }

        }

      },
    map:
      {
        _map: null,
        _init: function ()
        {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY, function ()
          {

            var myLatlng = new google.maps.LatLng(54.56,-2.844);
            var mapOptions = {

              zoom: 6,
              center: myLatlng
            }
            APPLICATION.Installation.map._map = new google.maps.Map(document.getElementById("map"),mapOptions);
            //load markers here.

            window.initMarkers();

          })

          var development

          $('#company_id_from, #company_id_to').not('.js-ignore').change(function ()
            {

              if ($(this).is('#company_id_from'))
              {
                development = $('#development_id_from')
              }

              else
              {
                development = $('#development_id_to')
              }

              var company_id = $(this).val()

              if ('' === company_id)
              {

                development.next('.dropdown-menu').html('')

                development.trigger('change')

              }

              else
              {
                APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown', function ()
                  {
                    development.trigger('change')
                  }
                )
              }

            }
          ).addClass('js-ignore').trigger('change')

          $('#development_id_from, #development_id_to').not('.js-ignore').change(function ()
            {

              var development_from = parseInt($('#development_id_from').val(), 10)

              var development_to = parseInt($('#development_id_to').val(), 10)

              if (!development_from || !development_to)
              {
                $('#distance').text('N/A')
              }

              else
              {

                for (var i = 0; i < window.mapMarkers.length; ++i)
                {

                  window.mapMarkers[i].setVisible(-1 !== [development_from, development_to].indexOf(window.mapMarkers[i]._development_id))

                }

                $('#distance').text('Calculating...')

                APPLICATION._APPLICATION.load($('#distance'), APPLICATION._PATH_PREFIX + 'development/distance?from=' + development_from + '&to=' + development_to, 'Development', 'distance')

              }

            }
          ).addClass('js-ignore').trigger('change')

        }

      },
    assignContractor:
      {
        _init: function()
        {

          $('.update-type').click(function(){

            $('[name="update_type"]').val($(this).attr('data-type'))
            $(this).parent().find('.js-submit').trigger('click');
          })
        }
      },
    assignDevelopment:
      {
        _init: function()
        {
          $('.update-type').click(function(){

            $('[name="update_type"]').val($(this).attr('data-type'))
            $(this).parent().find('.js-submit').trigger('click');
          })
        }
      },
    // Plots scripts
    plots:
      {

        _checkbox: null,

        // Method-wide scripts
        _init: function ()
        {

          // Process the links
          APPLICATION._APPLICATION.processLinks('#plots', 'Installation', 'plots', null, function ()
            {
              $('.js-hover-popover', '#plots').popover('destroy')
            }
          )

          $('.js-subduct_installation_type_id').not('.js-ignore').change(function ()
          {

            $.post(APPLICATION._PATH_PREFIX + 'installation/change-subduct-installation-type',
              {
                plot_id: $(this).data(APPLICATION._DATA_PREFIX + 'plot_id'),
                subduct_installation_type_id: $(this).val()
              }
            )

          }
          ).addClass('js-ignore')

          // On updating
          $('.js-installation_stage').not('.js-ignore').click(function ()
            {

              this.checked = true

              APPLICATION.Installation.plots._checkbox = $(this)

              var stage = $(this).val()

              var plot_id = $(this).data(APPLICATION._DATA_PREFIX + 'plot_id')

              APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'installation/remove-stage/' + plot_id + '/' + stage, 'Installation', 'removeStage')

            }
          ).addClass('js-ignore')

          // On updating
          $('.js-update').not('.js-ignore').change(function ()
            {

              // The plot
              var plot = $(this).closest('tr')

              // The data
              var data = {}

              // The name
              var name = $(this).attr('name')

              // The value
              var value = $(this).val()

              // Add the data
              data[name] = value

              // The plot ID
              var plot_id = $(this).data(APPLICATION._DATA_PREFIX + 'plot_id')

              // If account group
              if ('account_group_id' === name)
              {
                if (value != -1)
                {
                  APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'installation/assign-development/' + plot_id + '/' + value, 'Installation', 'assignDevelopment')
                  $('[name=contractor_id]', plot).val('').next().val('')
                }
              }

              else
              {
                // Post
                $.post(APPLICATION._PATH_PREFIX + 'installation/update-plot/' + plot_id, data, function (d)
                {
                  // If contractor
                  if ('contractor_id' === name)
                  {
                    if (value != -1)
                    {
                      APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'installation/assign-contractor/' + plot_id + '/' + value, 'Installation', 'assignContractor')
                      $('[name=account_group_id]', plot).val('').next().val('')
                    }
                  }
                  if (value == -1) {
                    location.reload();
                  }

                })
              }

            }
          ).addClass('js-ignore')

          // On changing the status
          $('.js-status').not('.js-ignore').change(function ()
            {
              this.checked = !this.checked
            }
          ).addClass('js-ignore')

        },

        // Build the maps
        initMap: function (map, latitude, longitude)
        {

          // Create the map
          var map = new google.maps.Map(document.getElementById(map),
            {
              center: new google.maps.LatLng(latitude, longitude),
              mapTypeId: google.maps.MapTypeId.TERRAIN,
              zoom: 10,
              gestureHandling: 'cooperative',
              disableDefaultUI: true
            }
          )

          new google.maps.Marker(
            {
              map: map,
              position: new google.maps.LatLng(latitude, longitude),
            }
          )

        },

        // Build the maps
        initUKMap: function (map, latitude, longitude)
        {

          // Create the map
          var map = new google.maps.Map(document.getElementById(map),
            {
              center: new google.maps.LatLng(54.093409, -2.89479),
              mapTypeId: google.maps.MapTypeId.TERRAIN,
              zoom: 4,
              gestureHandling: 'cooperative',
              disableDefaultUI: true
            }
          )

          new google.maps.Marker(
            {
              map: map,
              position: new google.maps.LatLng(latitude, longitude),
            }
          )

        }

      },

    // Plots Lite scripts (simplified version of plots for better performance)
    plotsLite:
      {

        // Method-wide scripts
        _init: function ()
        {

          // Process the links for tabs and pagination
          APPLICATION._APPLICATION.processLinks('#plots', 'Installation', 'plotsLite')

        }

      },

    // Edit plot scripts
    editPlot:
      {
        _internals: false,

        _externals: false,
        _cable: false,
        // Method-wide scripts
        _init: function ()
        {

          // Get the geolocation
          navigator.geolocation.getCurrentPosition(function (position)
            {

              // Set the latitude
              $('#latitude').val(position.coords.latitude)

              // Set the longitude
              $('#longitude').val(position.coords.longitude)

            }
          )
          $('#plot_type').on('change',function()
            {
              if ($(this).val() == 3)
              {
                //console.log('triggered')
                $('#title2_1').prop('hidden',false)
                $('#title2_2').prop('hidden',true)
              } else
              {
                $('#title2_1').prop('hidden',true)
                $('#title2_2').prop('hidden',false)
              }

              $('.plot_type_label').addClass('hidden')

              $('.plot_type_label[data-' + APPLICATION._DATA_PREFIX + 'plot_type_id="' + $(this).val() + '"]').removeClass('hidden')

            }
          ).trigger('change');

          $('.plot-issue-type').not('.js-ignore').change(function ()
            {

              if (this.checked)
              {
                $('#plot-issue-type-id-' + $(this).val()).show()
              }

              else
              {
                $('#plot-issue-type-id-' + $(this).val()).hide()
              }

            }
          ).addClass('js-ignore').trigger('change')
          $('#pon_number').not('.js-ignore').click(function()
          {

            if ($(this).prop('readonly'))
            {
              alert('Please select ONT Type')
            }

          }).addClass('js-ignore')
          $('#ont_type_id').on('change',function(){

            // if the type is not adtran
            if($(this).val() != 4){
              $('#router_bracket_id').val(2);
              $('.js-router_bracket_id .dropdown-menu li').each(function(){

                if($(this).find('a[data-' + APPLICATION._DATA_PREFIX + 'value="2"]').length > 0)
                {
                  $('.js-router_bracket_id .dropdown-toggle').val($(this).find('a[data-' + APPLICATION._DATA_PREFIX + 'value="2"]')[0].innerText)
                  $(this).addClass('active')
                }
                else{
                  $(this).removeClass('active')
                }
              })
              $('.js-router_bracket_id').css('display','none')
            }
            else{
              $('.js-router_bracket_id').css('display','block')
            }

            if (parseInt($(this).val(), 10))
            {
              $('#pon_number').prop('readonly', false)
            }

            else
            {
              $('#pon_number').prop('readonly', true)
            }

            // hard coded for new router
            if ($(this).val() && $(this).val()!="1")
            {
              // reveal dropdown for router location.
              $('.js-router_location_id').removeClass('hide');
            } else
            {
              $('.js-router_location_id').not('.hide').addClass('hide');
            }
          }).trigger('change');
          $('.stage-checkbox').not('.js-ignore').change(function ()
            {

              if (this.checked && 0 != $('.plot-issue-type:checked').length)
              {

                this.checked = false

                $('.modal-body', '#modal-warning').html('This plot has issues assigned to it. If these have now been resolved, they must be un-ticked before the installation can be recorded as complete.<br><br>Un-tick the relevant issues below and try again.')

                $('.modal-title', '#modal-warning').text('Unable to Complete Job – Remove Issues first')

                $('#modal-warning').modal()

              } else
              {
                if (this.name == 'internals')
                {
                  $('#internals_stock_location_id').parent().parent().removeClass('hide')

                }
                else if (this.name == 'externals')
                {
                  $('#externals_stock_location_id').parent().parent().removeClass('hide')
                }
                else if (this.name == 'fibre_installed')
                {
                  $('#fibre_installed_stock_location_id').parent().parent().removeClass('hide')
                }
              }



            }


          ).addClass('js-ignore')

          $('[name="internals"]').change(function()
          {

            if (this.checked)
            {
              $('.js-ont_type_id').show()
              $('.js-router-sn').show()
              $('.js-mac-address').show()
              $('#products-used1').show()
            }

            else
            {
              $('.js-ont_type_id').hide()
              $('.js-router-sn').hide()
              $('.js-mac-address').hide()
              $('#products-used1').hide()
            }

            // TODO : check date here and checkbox is now set
            if (this.checked && !$('[name="internals"]').hasClass('stage-completed'))
            {
              APPLICATION.Installation.editPlot.overtimeAlert(1);
            }

          });

          $('[name="fibre_installed"]').change(function()
          {
            if (this.checked)
            {
              $('.js-subduct_installation_type_id').show()
              $('#products-used3').show()
            }

            else
            {
              $('.js-subduct_installation_type_id').hide()
              $('#products-used3').hide()
            }
            // TODO : check date here and checkbox is now set
            if (this.checked && !$('[name="fibre_installed"]').hasClass('stage-completed'))
            {
              APPLICATION.Installation.editPlot.overtimeAlert(3);
            }
          });

          $('[name="fibre_connected"]').change(function()
          {
            // TODO : check date here and checkbox is now set
            if (this.checked && !$('[name="fibre_connected"]').hasClass('stage-completed'))
            {
              APPLICATION.Installation.editPlot.overtimeAlert(4);
            }
          });

          $('[name="externals"]').change(function()
          {

            if (this.checked)
            {
              $('#products-used2').show()
            }

            else
            {
              $('#products-used2').hide()
            }
            // TODO : check date here and checkbox is now set
            if (this.checked && !$('[name="externals"]').hasClass('stage-completed'))
            {
              APPLICATION.Installation.editPlot.overtimeAlert(2);
            }
          });

          // On save
          $('form').on('submit', function()
          {

            if (!$(this).hasClass('close-job-modal'))
            {
              // Completed checkbox
              var completed = $('input.stage-checkbox[name="completed"]:checked').length

              // Count number of stages complete
              var stages = $('input.stage-checkbox:not([name="completed"]):checked').length

              // Display job close down modal
              if (stages === 4 && !completed)
              {
                APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'installation/closeJobModal/', 'Installation', 'closeJobModal')

                return false
              }
            }


          })

        },
        overtimeAlert: function(t)
        {
          // get server time
          var overtime = ''
          $.ajax({
            type: "GET",
            url: APPLICATION._PATH_PREFIX + 'installation/overtime-check/',
            success : function (data)
            {

              overtime = parseInt(data)

              if (overtime == 1)
              {

                url = $('#coins_plot').val() + '/' + t

                // trigger modal popup with correct price etc.
                APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'installation/overtimePopup/' + url, 'Installation', 'overtimePopup')

              }

            }
          })

        }

      },
    overtimePopup:
      {
        _init: function()
        {

          // Disable modal close events
          $('#modal-container').off()

          $('.js-type').not('.js-ignore').change(function ()
            {

              if ('2' === $('.js-type:checked').val())
              {
                $('.js-engineers').show()
              }

              else
              {
                $('.js-engineers').hide()
              }

            }
          ).addClass('js-ignore')

        }
      },
    delete:
      {
        _init: function()
        {

          var $checkboxes = $("#delete_members");
          $checkboxes.on('change',function(){
            var ids = $checkboxes.filter(':checked').map(function(){
              return this.id;
            }).get().join(',');
            $('#members').val(ids);
          });

        }
      },
    // Productivity report scripts
    productivityReport:
      {

        // Method-wide scripts
        _init: function ()
        {

          if ($('#report').is('.js-can_search'))
          {
            APPLICATION._APPLICATION.search($('.js-url'))
          }

          // On changing the group
          $('#account_group_id').not('.js-ignore').change(function ()
            {

              // If empty
              if ('0' === $(this).val())
              {

                // Reset the engineer
                $('#engineer_id').val('0')

                // Hide the engineer dropdown
                $('#engineer_wrapper').hide()

              }

              // Otherwise
              else
              {

                // Load the dropdown
                APPLICATION._APPLICATION.loadDropdown($('#engineer_id'), APPLICATION._PATH_PREFIX + 'installation/engineer-dropdown/' + $(this).val() + '?engineer_id=' + $('#engineer_id').val(), 'Installation', 'engineer-dropdown', function ()
                  {
                    $('#engineer_wrapper').show()
                  }
                )
              }

            }
          ).addClass('js-ignore')

        }

      },

    busiestSites:
      {

        _init: function ()
        {
          APPLICATION._APPLICATION.load(
            $('#busiest-sites'),
            APPLICATION._PATH_PREFIX + 'installation/busiest-sites-search',
            'Installation',
            'busiestSitesSearch'
          )
        }

      },

    busiestSitesSearch:
      {

        _init: function ()
        {

          // Process the links
          APPLICATION._APPLICATION.processLinks('#busiest-sites', 'Installation', 'busiestSitesSearch')

          // On updating
          $('.js-update').not('.js-ignore').change(function ()
            {

              // The data
              var data = {}

              // The name
              var name = $(this).attr('name')

              // The value
              var value = $(this).val()

              // Add the data
              data[name] = value

              // The application ID
              var application_id = $(this).data(APPLICATION._DATA_PREFIX + 'application_id')

              // Post
              $.post(APPLICATION._PATH_PREFIX + 'application/update/' + application_id, data)

            }
          ).addClass('js-ignore')

        }

      },

    productivityReportResults:
      {

        _init: function ()
        {
          APPLICATION._APPLICATION.processLinks('#report', 'Installation', 'productivityReportResults')
        }

      },

    // Check in/out scripts
    checkinReport:
      {

        // Method-wide scripts
        _init: function ()
        {

          // Google Maps
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY)

          if ($('#report').is('.js-can_search'))
          {
            APPLICATION._APPLICATION.search($('.js-url'))
          }

          // On changing the group
          $('#account_group_id').not('.js-ignore').change(function ()
            {

              // If empty
              if ('0' === $(this).val())
              {

                // Reset the engineer
                $('#engineer_id').val('0')

                // Hide the engineer dropdown
                $('#engineer_wrapper').hide()

              }

              // Otherwise
              else
              {

                // Load the dropdown
                APPLICATION._APPLICATION.loadDropdown($('#engineer_id'), APPLICATION._PATH_PREFIX + 'installation/engineer-dropdown/' + $(this).val() + '?engineer_id=' + $('#engineer_id').val(), 'Installation', 'engineer-dropdown', function ()
                  {
                    $('#engineer_wrapper').show()
                  }
                )
              }

            }
          ).addClass('js-ignore')

        },

        // Build the maps
        initMap: function (map, latitude, longitude)
        {

          // Create the map
          var map = new google.maps.Map(document.getElementById(map),
            {
              center: new google.maps.LatLng(latitude, longitude),
              mapTypeId: google.maps.MapTypeId.TERRAIN,
              zoom: 10,
              gestureHandling: 'cooperative',
              disableDefaultUI: true
            }
          )

          new google.maps.Marker(
            {
              map: map,
              position: new google.maps.LatLng(latitude, longitude),
            }
          )

        },

      },

    checkinReportResults:
      {

        _init: function ()
        {

          // Process the links
          APPLICATION._APPLICATION.processLinks('#report', 'Installation', 'checkinReportResults', function ()
            {
              $('.js-hover-popover', '#report').popover('destroy')
            }
          )

        }

      },

    plotCommentsView:
      {

        _init: function ()
        {

          $('.js-remove-issue').not('.js-ignore').click(function ()
            {

              var div = $(this).closest('.js-plot-issue')

              var coins_plot_id = $(this).data(APPLICATION._DATA_PREFIX + 'coins_plot_id')

              var plot_issue_type_id = $(this).data(APPLICATION._DATA_PREFIX + 'plot_issue_type_id')

              $.ajax(APPLICATION._PATH_PREFIX + 'installation/plot-issue-remove/' + coins_plot_id + '/' + plot_issue_type_id,
                {

                  success: function (a)
                  {console.log(a)
                    div.html('<span class="text-danger">Removed</span>')
                  }

                }
              )

            }
          ).addClass('js-ignore')

        }

      },

    closeJobModal:
      {
        _init: function ()
        {

          // Remove disabled state on submit
          $('button[type=submit]').prop('disabled', false)

          // Continue
          $('.modal-footer .btn-link').one().on('click', function()
          {
            // Submit form
            $('form').addClass('close-job-modal').trigger('submit').removeClass('close-job-modal')
          })

          // Check completed
          $('.modal-footer button').one().on('click', function()
          {
            // Check the completed stage
            $('input.stage-checkbox[name="completed"]').prop('checked', true)

            // Close the modal
            $('body').removeClass('show-modal')

            // Submit form
            $('form').addClass('close-job-modal').trigger('submit').removeClass('close-job-modal')
          })

        }
      },

    outcodes:
      {

        _init: function ()
        {

          $('.js-account_group_id').not('.js-ignore').change(function ()
            {

              $.post(APPLICATION._PATH_PREFIX + 'account-group/postcode',
                {
                  postcode: $('.js-postcode', $(this).closest('tr')).val(),
                  account_group_id: $(this).val()
                }
              )

            }
          ).addClass('js-ignore')

        }

      },

    toggleInternalFibre: function()
    {

      var selectedOption = parseInt($('#plot_type').val(), 10)

      $('#internal-fibre-wrapper').hide()

      if (selectedOption === 2 || selectedOption === 3)
      {
        $('#internal-fibre-wrapper').show()
      }

    },

    faults:
      {

        _init: function ()
        {
          APPLICATION._APPLICATION.search($('.js-url'))
        }

      },

    faultsList:
      {

        _init: function ()
        {
          APPLICATION._APPLICATION.processLinks('#faults', 'Installation', 'faultsList')
        }

      },

  }
